<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :maskClosable="false"
    :forceRender="true"
    :style="modalStyle"
    fullscreen
    switchFullscreen
    @cancel="handleCancel"
    wrapClassName="ant-modal-cust-warp">
    <template slot="footer">
      <a-button key="templateSetting" type="primary" icon="setting" @click="handleTemplateSetting">模板设置</a-button>
      <a-button key="back" @click="handleCancel">关闭(ESC)</a-button>
    </template>
    <a-form :form="form">
      <template>
        <iframe ref="printIframe" :src="billPrintUrl" :height="height" style="width: 100%; border: none;"></iframe>
      </template>
      <template>
        <a-row>
          <a-col>
            <a-form-item>
              <a-input v-decorator="['id']" hidden/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </a-form>
  </j-modal>
</template>

<script>
  import pick from 'lodash.pick'
  import {mixinDevice} from '@/utils/mixin'
  
  // 单据类型映射 - 中文名称到英文代码
  const BILL_TYPE_MAP = {
    '请购单': 'purchase_apply',
    '采购订单': 'purchase_order',
    '采购入库': 'purchase_in',
    '采购退货': 'purchase_return',
    '采购退货出库': 'purchase_return',
    '销售订单': 'sales_order',
    '销售出库': 'sales_out',
    '销售退货': 'sales_return',
    '销售退货入库': 'sales_return',
    '零售出库': 'retail_out',
    '零售退货': 'retail_return',
    '零售退货入库': 'retail_return',
    '其它入库': 'other_in',
    '其它出库': 'other_out',
    '组装单': 'assemble',
    '拆卸单': 'disassemble',
    '调拨出库': 'transfer_out'
  }
  
  export default {
    name: 'BillPrintProIframe',
    mixins: [mixinDevice],
    data () {
      return {
        title: "三联打印预览",
        width: '1500px',
        visible: false,
        modalStyle: '',
        billPrintUrl: '',
        height: "",
        model: {},
        form: this.$form.createForm(this),
        loading: false,
        billType: '',
        billTypeCode: ''
      }
    },
    created () {
    },
    methods: {
      show(record, billPrintUrl, billPrintHeight, billType) {
        this.height = billPrintHeight
        this.billPrintUrl = billPrintUrl
        this.visible = true
        this.modalStyle = 'top:20px;height: 95%;'
        this.model = Object.assign({}, record)
        
        // 设置单据类型
        if (billType) {
          this.billType = billType
          this.billTypeCode = this.getBillTypeCode(billType)
        }
        
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'id'))
        });
      },
      
      // 获取单据类型英文代码
      getBillTypeCode(billType) {
        return BILL_TYPE_MAP[billType] || billType
      },
      
      // 模板设置 - 跳转到模板设计器
      handleTemplateSetting() {
        this.$confirm({
          title: '进入模板设置',
          content: '即将跳转到模板设计器，当前预览将关闭。是否继续？',
          onOk: () => {
            // 关闭当前模态框
            this.close()
            
            // 跳转到模板设计器
            const query = {
              billType: this.billTypeCode,
              billTypeName: this.billType,
              no: this.model.number
            }
            
            this.$router.push({
              path: '/print-template/designer',
              query: query
            })
          }
        })
      },
      
      handleCancel() {
        this.close()
      },
      
      close() {
        this.billPrintUrl = ''
        this.$emit('close')
        this.visible = false
        this.modalStyle = ''
      }
    }
  }
</script>

<style scoped>

</style>
